<template>
  <LoadingButton
      :processing="processing"
      btn-text="Unassign"
      class="btn btn-danger"
      processing-text="working..."
      @click.prevent="handleAssign"
  />
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import LoadingButton from "@/components/form/LoadingButton";

export default {
  name: "UnassignUser",
  props: {
    application: {
      default: null
    },
    userId: {
      default: null
    }
  },
  emits: ["application-unassigned"],
  data: () => ({
    processing: false
  }),
  watch: {
    async getPusherNotification(param) {
      switch (param.type) {
        case 'assign-application':
          this.processing = false;
          break;
      }
    }
  },
  components: {
    LoadingButton
  },
  computed: {
    ...mapGetters(["getPusherNotification"])
  },
  methods: {
    ...mapActions(["unassignApplication"]),
    async handleAssign() {
      if (!confirm("Unassign this application?")) {
        return;
      }
      this.processing = true;
      let applicationId = this.application?.id;
      let userId = this.userId;
      await this.unassignApplication({
        applicationId,
        userId
      })
          .then(() => {
            this.$emit("application-unassigned");
            this.$router.push({
              name: "Dashboard",
              params: {
                uuid: this.application?.uuid
              }
            });
          })
          .catch(err => console.log(err));
    }
  }
};
</script>
<style lang="scss" scoped></style>
